import React, { ReactNode } from 'react'
import { Navigate, Outlet, useParams, useSearchParams } from 'react-router-dom'

import { userIsGuest } from '@utils/helpers'
import { useAppState } from '@src/app.state'

type ProtectedRouteProps = {
  blockedRoles?: OrgRole[]
  children?: ReactNode
}

export const ProtectedRoute = ({
  blockedRoles,
  children,
}: ProtectedRouteProps): ReactNode => {
  const user = useAppState(state => state.user)
  const isAuthenticated = useAppState(state => state.isAuthenticated)
  const appLoading = useAppState(state => state.appLoading)
  const { orgId } = useParams()
  const [searchParams] = useSearchParams()
  const hasToken = searchParams.get('token') || searchParams.get('editToken')

  if (!isAuthenticated && !hasToken && !appLoading)
    return <Navigate to="/sign-in" />

  if (!user?.orgRoles) return null

  let hasBlockedRole = false
  if (blockedRoles?.length && orgId) {
    hasBlockedRole = blockedRoles.includes(user?.orgRoles[orgId] as OrgRole)
  }
  if (user?.isAnonymous && !hasToken) return <Navigate to="/sign-in" />
  if (userIsGuest(user)) return children ? children : <Outlet />
  if (!user?.isSuperAdmin && hasBlockedRole)
    return <Navigate to={`/${orgId}`} />

  return children ? children : <Outlet />
}
